import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Trophy } from 'lucide-react';
import { ActiveChallenges } from '@/components/accountability/ActiveChallenges';
import { ContextualNotificationPrompt } from "@/components/notifications/ContextualNotificationPrompt";

export function CommunityChallenges() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Users className="h-5 w-5 text-secondary" />
          Community Challenges
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          Group challenges you're participating in with others. Achieve more together.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <ActiveChallenges />
        <ContextualNotificationPrompt context="challenges" />
      </CardContent>
    </Card>
  );
}
